<template src="./form.html"></template>

<script>
import { UpdateVisit, ViewVisit } from '@/api/visit'

export default {
  name: 'edit-visit',
  data: function () {
    return {
      model: {
        id: '',
        order: '',
        baseline: null,
        visit_at: null,
        lower: null,
        upper: null
      },
      loading: false,
      ruleValidate: {
        visit: [{
          required: true,
          message: '访视不能为空',
          trigger: 'change'
        }]
      }
    }
  },
  props: ['meta'],
  methods: {
    init: function (id) {
      ViewVisit(id).then(async res => {
        this.model = res
      })
    },
    handleSubmit: function (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.postForm()
        } else {
          this.$Message.error('信息填写有误!')
        }
      })
    },
    postForm: function () {
      UpdateVisit(this.model).then(async res => {
        if (res.id) {
          this.$emit('refresh')
        }
      })
    }
  }
}
</script>
